import { selectFromSolutionStatusOnlyDto } from '../../models';

export default selectFromSolutionStatusOnlyDto()
  .id
  .projectId
  .actionType
  .solutionStatus(s => s.name)
  .assignAction(a => a
    .targetRouteId
    .details(d => d
      .eventUuids
      .routeUuids))
  .toString();
